<template>
  <header class="app-header">
    <div class="header-content">
      <div class="header-left">
        <!-- <button v-if="showMenu" @click="toggleMenu" class="action-btn menu-btn">
          <span>☰</span>
        </button> -->
        <router-link class="logo-container" :to="'/dashboard'" style="cursor: pointer;">
          <img class="logo-icon" :src="require('../assets/viaerpwhite.png')" alt="ViaPOS Logo">
          <div>
            <h2 class="header-title">{{ title }}</h2>
          </div>
        </router-link>
      </div>
      <div class="header-right">
        <div class="profile-info" v-if="username">
          <div class="profile-icon-wrapper">
            <i class="fas fa-user"></i>
          </div>
          <span class="profile-name">{{ username }}</span>
        </div>
        <button v-if="showBack" @click="handleBack" class="action-btn back-btn">
          <span>Back</span>
        </button>
        <button v-if="showLogout" @click="handleLogout" class="action-btn logout-btn">
          <span>Logout</span>
        </button>
      </div>
    </div>

    <!-- Side Drawer -->
    <!-- <div class="side-drawer" :class="{ 'open': isMenuOpen }">
      <div class="drawer-header">
        <h3 style="color: white; margin: 0;">Menu</h3>
        <button class="action-btn close-btn" @click="toggleMenu">×</button>
      </div>
      <div class="drawer-content">
        <slot name="menu"></slot>
      </div>
    </div>
    <div class="drawer-overlay" v-if="isMenuOpen" @click="toggleMenu"></div> -->
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      default: 'Via Retail'
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showLogout: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMenuOpen: false,
      username: ''
    };
  },
  mounted() {
    this.username = localStorage.getItem('username') || '';
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleBack() {
      const ref = document.referrer || '';
      const origin = window.location.origin;
      const isInternal = ref.startsWith(origin) || ref.includes('viapos.via-app.ca');
      if (isInternal) {
        this.$router.go(-1);
      } else {
        this.$router?.push('/dashboard');
      }
    },
    handleLogout() {
      localStorage.clear();
      this.$router?.push({ name: 'login' });
    }
  }
};
</script>

<style scoped>
.app-header {
  background: var(--theme-primary, #5c6bc0); /* Fallback color if var not defined */
  margin-top: -30px;
  box-shadow: 0 4px 20px rgba(92, 107, 192, 0.3);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  width: 100%;
  margin-bottom: 20px;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-right {
  display: flex;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease;
}

.logo-icon:hover {
  transform: scale(1.05) rotate(5deg);
}

.header-title {
  margin: 0;
  color: white;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.action-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 1rem;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
}

.profile-info:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-icon-wrapper {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--theme-primary, #5c6bc0);
  font-size: 1.1rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.profile-name {
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 0.3px;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.action-btn:active {
  transform: translateY(0);
}

.menu-btn {
  padding: 0.5rem 1rem;
}

/* Side Drawer Styles */
.side-drawer {
  position: fixed;
  top: 0;
  left: -300px;
  width: 300px;
  height: 100vh;
  background: #333;
  z-index: 1000;
  transition: left 0.3s ease;
  box-shadow: 2px 0 10px rgba(0,0,0,0.5);
  overflow-y: auto;
}

.side-drawer.open {
  left: 0;
}

.drawer-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.drawer-content {
  padding: 1rem;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 999;
}

@media (max-width: 768px) {
  .header-content {
    padding: 1rem;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .logo-icon {
    width: 48px;
    height: 48px;
    font-size: 1.5rem;
  }

  .action-btn {
    padding: 0.625rem 1.25rem;
    font-size: 0.9rem;
  }
  
  .header-title {
    font-size: 1.5rem;
  }
}
</style>
